import { Alert, Dialog, IconButton } from "@mui/material";
import {
  TncActions,
  TncActionsWrapper,
  TncHeader,
  TncWrapper,
  TnCData,
  TnCButton,
} from "./TermAndConditionsDialog.styles";
import { FC, useRef, RefObject, useState, useEffect } from "react";
import PageScrollSkip from "../../components/PageScrollSkip/PageScrollSkip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import LoadingCircles from "../../components/LoadingCircles/LoadingCircles";
import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import useCMSTermsAndCondtions from "hooks/CMS/TermsAndCondtions/TermsAndCondtions";

type TermAndConditionsDialogProps = {
  isOpen: boolean;
  setIsOpen: (toogle: boolean) => void;
};

const TermAndConditionsDialog: FC<TermAndConditionsDialogProps> = ({
  isOpen,
  setIsOpen,
}) => {
  const tncWrapperRef = useRef<HTMLElement>(null);
  const [showError, setShowError] = useState(true);
  const { isLoading, error, termsAndConditions } = useCMSTermsAndCondtions();

  useEffect(() => {
    setShowError(true);
  }, [error]);

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      sx={{
        overflow: "hidden",
        "& .MuiPaper-root": {
          padding: "0px 0px 0px 0px !important",
          maxWidth: "1000px !important",
          width: "100% !important",
        },
      }}
    >
      <TncWrapper ref={tncWrapperRef as RefObject<HTMLDivElement>}>
        <TncHeader>
          <h1>{termsAndConditions?.title}</h1>
          {termsAndConditions?.intro && <PortableText {...termsAndConditions?.intro} />}
          <IconButton
            sx={{ height: "25px", width: "25px" }}
            size="small"
            onClick={() => {
              setIsOpen(false);
            }}
            data-testid="CrossButton"
          >
            <FontAwesomeIcon icon={faX} color="#2E2E2E" />
          </IconButton>
        </TncHeader>
        {error && showError && (
          <Alert
            severity="error"
            sx={{ width: "100%" }}
            onClose={() => {
              setShowError(false);
            }}
          >
            Sorry somthing went wrong
          </Alert>
        )}
        {isLoading ? (
          <div style={{ padding: "20px" }}>
            <LoadingCircles isLoading withoutDialogue />
          </div>
        ) : (
          <TnCData

            >
              {termsAndConditions?.content && <PortableText {...termsAndConditions.content} />}
            </TnCData>
        )}

        <TncActionsWrapper>
          <PageScrollSkip refInput={tncWrapperRef} />
          <TncActions>
            <TnCButton
              onClick={() => {
                setIsOpen(false);
              }}
            >
              Close
            </TnCButton>
          </TncActions>
        </TncActionsWrapper>
      </TncWrapper>
    </Dialog>
  );
};

export default TermAndConditionsDialog;
